import LandingPage from "./views/LandingPage/LandingPage.jsx";
import LoginPage from "./views/LoginPage/LoginPage";
import RequestResetPage from "./views/LoginPage/RequestResetPage";
import NewPasswordPage from "./views/LoginPage/NewPasswordPage";
import SignupPage from "./views/SignupPage/SignupPage";
import ProfilePage from "./views/ProfilePage/ProfilePage";
import ManageServices from "./views/Management/ManageServices";
// import BlogPage from "./views/BlogPage/BlogPage";
import AboutUsPage from "./views/AboutUsPage/AboutUsPage";
import ContactUsPage from "./views/ContactUsPage/ContactUsPage";
import TermsPage from "./views/TermsPage/TermsPage";
import Catalog360Page from "./views/360CatalogPage/360CatalogPage";
// import View360Page from "./views/360ViewPage/360ViewPage";

import AccommodationsPage from "./views/AccommodationsPage/AccommodationsPage";
import AccommodationDetailPage from "./views/AccommodationDetailPage/AccommodationDetailPage";
import BookingAccommodationPage from "./views/BookingFormPage/BookingFormPage";
import ReservationPaymentResultPage from "./views/ReservationPaymentResultPage/ReservationPaymentResultPage";

import ToursPage from "./views/ToursPage/ToursPage";
import TourDetailPage from "./views/TourDetailPage/TourDetailPage";
import BookingTourPage from "./views/BookingFormTourPage/BookingFormTourPage";

//import ChristmasRoutes from "./views/SpecialSeasons/ChristmasRoutes";

let indexRoutes = [
    { path: "/", name: "LandingPage", component: LandingPage, private: false },
    { path: "/login", name: "LoginPage", component: LoginPage, private: false },
    { path: "/signup", name: "SignupPage", component: SignupPage, private: false },
    { path: "/olvido-contrasena", name: "RequestResetPage", component: RequestResetPage, private: false },
    { path: "/reestablecimiento-contrasena", name: "NewPasswordPage", component: NewPasswordPage, private: false },
    { path: "/profile", name: "ProfilePage", component: ProfilePage, private: true },
    { path: "/gestionar-servicios", name: "ManageServices", component: ManageServices, private: true },
    // { path: "/blog", name: "BlogPage", component: BlogPage, private: false },
    { path: "/catalogo", name: "Catalogo", component: AccommodationsPage, private: false },
    { path: "/accommodations", name: "AccommodationsPage", component: AccommodationsPage, private: false },
    { path: "/accommodation/:id", name: "AccommodationDetailPage", component: AccommodationDetailPage, private: false },
    { path: "/booking-accommodation", name: "BookingAccommodationPage", component: BookingAccommodationPage, private: false },
    { path: "/reservation-payment-result", name: "ReservationPaymentResultPage", component: ReservationPaymentResultPage, private: false },
    { path: "/quienes-somos", name: "AboutUsPage", component: AboutUsPage, private: false },
    { path: "/contacto", name: "ContactUsPage", component: ContactUsPage, private: false },
    { path: "/terminos-y-condiciones", name: "TermsPage", component: TermsPage, private: false },
    { path: "/contenido-360", name: "Catalog360Page", component: Catalog360Page, private: false },
    // { path: "/vista-360/:id", name: "View360Page", component: View360Page, private: false },
    { path: "/tours", name: "ToursPage", component: ToursPage, private: false },
    { path: "/catalogo-tours", name: "CatalogoTours", component: ToursPage, private: false },
    { path: "/tour/:id", name: "TourDetailPage", component: TourDetailPage, private: false },
    { path: "/booking-tour", name: "BookingTourPage", component: BookingTourPage, private: false },
    //{ path: "/rutas-navidenas", name: "RutasNavideñas", component: ChristmasRoutes, private: false },
    //{ path: "/christmas-routes", name: "ChristmasRoutes", component: ChristmasRoutes, private: false }
];

export default indexRoutes;


// WEBPACK FOOTER //
// ./src/routes.jsx